import { z } from "zod";
import { AgentId } from "../primitives";
import { FirebaseTimestamp } from "../record.firestore";
import { NotificationDeliveryMethod } from "./notificationDeliveryMethod";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const NotificationAttempt = z.object({
    sentAt: FirebaseTimestamp,
    sentBy: AgentId,
    notificationMethod: NotificationDeliveryMethod,
});

export const NotificationAttempts = z.array(NotificationAttempt);

export type NotificationAttempt = z.infer<typeof NotificationAttempt>;
